import React from "react";
import HeadLogo from "./components/HeadLogo";
import Playlist from "./components/Playlist";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import bg from "./img/ST-bg-3.jpg";

const baseColor = "#e50914";

const PlaylistBlock = styled.div`
  background-color: black;
  height: 100vh;
  background-image: url(${bg});
  background-size: 100%;
  background-repeat: no-repeat;
  iframe {
    width: 80%;
    height: 380px;
    display: block;
    margin: 0 auto;
  }
  .title {
    text-shadow: 0px 0px 5px black;
    margin-bottom: 0;
    margin-top: 0;
    .subtitle {
      font-size: 20px;
      margin: 0;
      width: 70%;
      line-height: 22px;
      margin: 0 auto 10px auto;
    }
  }

  .logo {
    position: relative;
    z-index: 99;
  }

  img {
    width: 100%;
  }

  .btn {
    background-color: ${baseColor} !important;
    font-size: 30px !important;
    color: white !important;
    padding: 5px 60px !important;
    &:hover {
      color: white;
    }
  }

  .mb {
    margin-bottom: 25px;
  }

  .mt2 {
    margin-top: 50px;
  }

  input {
    width: 280px;
    background-color: transparent;
    border-radius: 50px;
    border: 3px solid ${baseColor};
    color: white !important;
    outline: none;
    padding: 5px 0 1px 11px;
  }

  .mob_one-col {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .error {
    font-size: 15px;
    margin-top: 5px;
    opacity: 0.8;
    text-align: center;
  }

  .centerabs {
    position: absolute;
    top: 60%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
  }

  .title {
    font-size: 30px;
    line-height: 35px;
    margin: 0 auto 20px auto;
    text-align: center;
    color: white;
    .subtitle {
      font-size: 20px;
      text-align: center;
      display: block;
    }
  }

  .hide {
    display: none !important;
  }

  .url {
    color: white;
    text-decoration: none;
    position: absolute;
    bottom: 15px;
    width: 100%;
    text-align: center;
    text-transform: lowercase;
  }

  .url:active {
    color: #d81f26;
  }

  .url2 {
    position: relative;
    text-align: center;
    display: block;
  }

  .mt90 {
    margin-top: 90px;
  }
`;

export default function PlayList_page() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Netflix | Playlist</title>
      </Helmet>
      <PlaylistBlock className="Playlist">
        <HeadLogo />
        <div className="centerabs">
          <p className="title">
            Vecna est en approche ! <br />
            <p className="subtitle">
              Mettez votre casque et évadez-vous grâce à vos chansons préférées
              pour lui échapper !
            </p>
          </p>
          <Playlist />
        </div>
      </PlaylistBlock>
    </>
  );
}
